module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule,
      "account": _vm.account
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('panel', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "title": "Atributos personalizados da variação (opcional)"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--info",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addVarAttrRow.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Adicionar linha\n        ")])]), _vm._v(" "), (!_vm.variation.customAttributes.length) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('small', {
    staticClass: "form-help"
  }, [_vm._v("Sem atributos nesta variação. Clique em “Adicionar linha”.")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.variation.customAttributes), function(attr, idx) {
    return _c('div', {
      key: ("var-" + _vm.skuSafe + "-attr-" + idx),
      staticClass: "l-row attr-row"
    }, [_c('form-group', {
      attrs: {
        "label": 'Chave',
        "columns": 5,
        "error": _vm.getError(("customAttributes[" + idx + "].key"), _vm.productId, _vm.variation.sku),
        "required": true
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (attr.key),
        expression: "attr.key",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs(),
        "placeholder": "Ex.: Cor secundária"
      },
      domProps: {
        "value": (attr.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attr, "key", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('form-group', {
      attrs: {
        "label": 'Valor',
        "columns": 5,
        "error": _vm.getError(("customAttributes[" + idx + "].value"), _vm.productId, _vm.variation.sku),
        "required": true
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (attr.value),
        expression: "attr.value",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs(),
        "placeholder": "Ex.: Bordô"
      },
      domProps: {
        "value": (attr.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attr, "value", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "l-col-2@md attr-actions"
    }, [_c('button', {
      staticClass: "btn btn--danger",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeVarAttrRow(idx)
        }
      }
    }, [_vm._v("\n            Remover\n          ")])])], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e30395a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/magalu/provide/Variation.vue
// module id = 3149
// module chunks = 0